/**
 * 文本切句器
 *
 * 作用:
 * AI流式返回文本时
 * 根据标点切成完整句子
 */

import {
    DEFAULT_PUNCTUATION
} from "../constants/TTSConstants";

export default class SentenceSplitter{
    constructor(options={}){
        // 切割符号
        this.punctuation= options.punctuation || DEFAULT_PUNCTUATION;
        // 未完成文本缓存
        this.buffer="";
    }

    /**
     * 添加文本
     *
     * @param text AI返回文本片段
     *
     * @return 完整句子数组
     */
    append(text){
        if(!text){
            return [];
        }

        this.buffer+=text;
        const sentences=[];
        let start=0;

        for(let i=0; i<this.buffer.length; i++){
            const char=this.buffer[i];

            if(this.punctuation.includes(char)){
                const sentence= this.buffer.substring(start, i+1);
                if(sentence.trim()){
                    sentences.push(sentence.trim());
                }
                start=i+1;
            }
        }

        // 保存未完成部分
        this.buffer= this.buffer.substring(start);
        return sentences;
    }

    /**
     * 获取剩余文本
     *
     * AI结束时调用
     */
    flush(){
        const text= this.buffer.trim();
        this.buffer="";
        return text ? [text] : [];
    }

    /**
     * 清空
     */
    clear(){
        this.buffer="";
    }

}